import { Request } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import { AuthznApiUri } from './uri';

export class SettingsAuthProvider {
  public static reRegisterLcmWithVidm = (): Promise<Request> => {
    return Http.post<Request>(AuthznApiUri.SET_AUTH_PROVIDER_URL).then(
      res => res.data
    );
  };

  public static updateLcmHostnameWithAuthProvider = (
    lcmHostname: string
  ): Promise<Request> => {
    return Http.post<Request>(AuthznApiUri.UPDATE_LCM_HOST_WITH_AUTH_PROVIDER, {
      lcmHostUri: `https://${lcmHostname}`,
      lcmHostname
    }).then(res => res.data);
  };
}
